import { Injectable } from '@angular/core';
import { Travel } from '../models/travel';
import { environment } from '../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AuthService } from '../auth-n-routing/auth-service.service';
import { DateHandlerService } from '../commons/date-handler.service';
import { Vehicle } from '../models/vehicle';
import { Motivation } from '../models/travel-motivation';
import {BusyServices} from '../commons/busy.service';


@Injectable()
export class TravelsHandlerService {

	private addTravelURI = 'travels/add';
	private startTravelURI = 'travels/start';
	private closeTravelURI = 'travels/close';
	private cancelRequestTravelURI = 'travels/cancelRequest';
	private forceCloseTravelURI = 'travels/forceClose';
	private getByUserIDURI = 'travels/getByUserID';
	private getByAdminIDURI = 'travels/getByAdminID';
	private getByAdminIDCountURI = 'travels/getByAdminIDCount';
	private getByUserIDCountURI = 'travels/getByUserIDCount';
	private findOpenTravelURI = 'travels/findOpenTravel';
	private approveURI = 'travels/approve';
	private declineURI = 'travels/decline';
	private restoreURI = 'travels/restore';
	private getMaxKmURI = 'travels/maxKm';
	private getMaxKmByVehicleIDUri = 'travels/getMaxKmByVehicleID';
	private getTravelsByVehicleIDUri = 'travels/getByVehicleID';
	private updateKilometers = 'travels/updateKilometers';
	private getTravelForAdminCalendarURI = 'travels/getTravelForAdminCalendar';
	private getTravelsByParkIdURI = 'travels/getTravelsByParkId';
	private changeVehicleToTravelURI = 'travels/changeVehicleToTravel';
	private adminUpdateTravelURI = 'travels/adminUpdateTravel';
	private getTravelMotivationsURI = 'travels/motivations';


	travels_list: Travel[] = [];
	travels_list_props = {
		count: 0,
		current_page: 1,
		item_per_page: 10,
		filtro_value: '',
		filter_column: '',
		filter_value: '',
		status_attivo: 1,
		data_in: null,
	};

  travels_status_mapping = new Map<string, string>();


	constructor(private busy: BusyServices, private http: HttpClient,
				private dateHandlerService: DateHandlerService,
				private authService: AuthService
	) {
    this.travels_status_mapping.set('annullatoOfficer','Annullato Officer');
    this.travels_status_mapping.set('concluso','Concluso');
    this.travels_status_mapping.set('inCorso','In Corso');
    this.travels_status_mapping.set('approvato','Approvato');
    this.travels_status_mapping.set('richiesto','Richiesto');
    this.travels_status_mapping.set('annullatoUtente','Annullato Utente');
  }


	findOpenTravel(): Promise<Travel> {
		return new Promise<Travel>((resolve, reject) => {
			const _http = this.http.post(environment.api.baseUrl + this.findOpenTravelURI,
				{ 'user_id': this.authService.getAuthenticatedUser().id },
				environment.api.config).subscribe(
				(data: any) => {
					if (data.travel) {
						const trav = new Travel(data.travel);
						resolve(trav);
					} else {
						reject();
					}
				});
			this.busy.setBusy(_http);
		});
	}

	getTravelsByVehicleID(vehicle_id: string, page_number): Promise<Travel[]> {
		return new Promise<Travel[]>((resolve, reject) => {
			const _http = this.http.post(environment.api.baseUrl + this.getTravelsByVehicleIDUri,
				{ 'vehicle_id': vehicle_id, 'page_number': page_number },
				environment.api.config).subscribe(
				(data: any) => {
					const toRet = [];
					if (data.data) {
						data.data.forEach((travel) => {
							toRet.push(new Travel(travel['travel']));
						});
					}
					resolve(toRet);
				});
			this.busy.setBusy(_http);
		});
	}

	startTravel(travel: Travel): Promise<Travel> {
		return new Promise<Travel>((resolve, reject) => {
			const body = {

				'start_latitude': travel.start_latitude,
				'start_longitude': travel.start_longitude,
				'start_altitude': travel.start_altitude,

				'start_kilometers': travel.start_kilometers,
				'first_reporting': travel.first_reporting,
				'started_at': this.dateHandlerService.formatDate(travel.started_at_app),
				'user_id': travel.user.id,
				'travel_id': travel.id
			};
			const _http = this.http.post(environment.api.baseUrl + this.startTravelURI,
				body, environment.api.config).subscribe(
				(data: any) => {
					if (data.travel) {
						console.log(data.travel);
						resolve(new Travel(data.travel));
					} else {
						reject();
					}
				}, err => {
					console.log(err);
					reject();
				});
			this.busy.setBusy(_http);
		});
	}

	addTravel(travel: Travel, park_id: string, vehicle_id: string): Promise<Travel> {
		return new Promise<Travel>((resolve, reject) => {
			const body = {
				'route': travel.route,
				'route_modified': travel.route_modified,
				'motivation': travel.motivation,
				'motivation_other': travel.motivation_other,
				'passengers': travel.passengers,
				'user_id': travel.user.id.toString(),
				'park_id': park_id.toString(),
				'vehicle_id': vehicle_id.toString(),
				'required_from': this.dateHandlerService.formatDate(travel.required_from),
				'required_to': this.dateHandlerService.formatDate(travel.required_to),
				'is_admin' : this.authService.is_admin() ? 1 : 0
			};

			const _http = this.http.post(environment.api.baseUrl + this.addTravelURI,
				body, environment.api.config).subscribe(
				(data: any) => {
					if (data.travel) {
						// Se i dati che provengono dal backend non sono vuoti ed esiste però un messaggio di errore
						if (!!data.travel.message) {
							reject(data.travel.message);
						} else { // Se non esiste un messaggio di errore il travel è completo è si può procedere
							console.log(data.travel);
							resolve(new Travel(data.travel));
						}
					} else {
						console.log('reject');
						reject();
					}
				}, err => {
					console.log('errore dal backend');
					reject();
				});
			this.busy.setBusy(_http);
		});
	}

	closeTravel(travel: Travel): Promise<Travel> {
		return new Promise<Travel>((resolve, reject) => {
			const body = {
				'end_latitude': travel.end_latitude,
				'end_longitude': travel.end_longitude,
				'end_altitude': travel.end_altitude,
				'route': travel.route,
				'route_modified': travel.route_modified,
				'end_kilometers': travel.end_kilometers,
				'ended_at': this.dateHandlerService.formatDate(travel.ended_at),
				'reporting': travel.reporting,
				'fuel_level': travel.fuel_level,
				'trv_id': travel.id
			};
			const _http = this.http.post(environment.api.baseUrl + this.closeTravelURI,
				body, environment.api.config).subscribe(
				(data: any) => {
					if (data.travel) {
						resolve(new Travel(data.travel));
					} else {
						reject();
					}
				});
			this.busy.setBusy(_http);
		});
	}

	forceCloseTravel(travel: Travel): Promise<Travel> {
		return new Promise<Travel>((resolve, reject) => {
			const body = {
				'travel_id': travel.id
			};
			const _http = this.http.post(environment.api.baseUrl + this.forceCloseTravelURI,
				body, environment.api.config).subscribe(
				(data: any) => {
					if (data.travel) {
						resolve(new Travel(data.travel));
					} else {
						reject();
					}
				});
			this.busy.setBusy(_http);
		});
	}

	cancelRequestTravel(travel: Travel): Promise<Travel> {
		return new Promise<Travel>((resolve, reject) => {
			const body = {
				'ended_at': this.dateHandlerService.formatDate(new Date()),
				'trv_id': travel.id
			};
			const _http = this.http.post(environment.api.baseUrl + this.cancelRequestTravelURI,
				body, environment.api.config).subscribe(
				(data: any) => {
					if (data.travel) {
						resolve(new Travel(data.travel));
					} else {
						reject();
					}
				});
			this.busy.setBusy(_http);
		});
	}

	restoreBodyTravelsFilters() {
		this.travels_list_props = {
			count: 0,
			current_page: 1,
			item_per_page: 10,
			filtro_value: '',
			filter_column: '',
			filter_value: '',
			status_attivo: 1,
			data_in: null,
		};
	}

	getBodyTravelsFilter(user_id: number) {
		return {
			'user_id': user_id.toString(),
			'page_number': this.travels_list_props.current_page.toString(),
			'items_per_page': this.travels_list_props.item_per_page.toString(),
			'status_attivo': this.travels_list_props.status_attivo,
			'filter_column': this.travels_list_props.filter_column,
			'filter_value': this.travels_list_props.filter_value,
			'data_in': this.dateHandlerService.formatDateNoTime(this.travels_list_props.data_in),
		};
	}

	reloadTravelsListAndCount(): Promise<boolean> {
		return new Promise<boolean>(resolve => {
			this.getTravelsCount(this.authService.getAuthenticatedUser().id).then((counted) => {
				this.travels_list_props.count = counted;
				this.reloadTravelsList().then(res => {
					resolve(res);
				});
			});
		});
	}

	reloadTravelsList(): Promise<boolean> {
		return new Promise<boolean>(resolve => {
			if (this.authService.is_admin()) {
				this.getByAdminID(this.authService.getAuthenticatedUser().id).then((data) => {
					this.travels_list = data;
					resolve(true);
				});
			} else {
				this.getByUserID(this.authService.getAuthenticatedUser().id).then((data) => {
					this.travels_list = data;
					resolve(true);
				});
			}
		});
	}

	getByUserID(user_id: number): Promise<Travel[]> {
		return new Promise<Travel[]>((resolve, reject) => {
			const _http = this.http.post(environment.api.baseUrl + this.getByUserIDURI,
				this.getBodyTravelsFilter(user_id), environment.api.config).subscribe(
				(data: any) => {
					const toRet = [];
					if (data.data) {
						data.data.forEach((vehicle_server_obj) => {
							const travel_raw = vehicle_server_obj['travel'];
							toRet.push(new Travel(travel_raw));
						});
					}
					resolve(toRet);
				});
			this.busy.setBusy(_http);
		});
	}

	getByAdminID(user_id: number): Promise<Travel[]> {
		return new Promise<Travel[]>((resolve, reject) => {
			const _http = this.http.post(environment.api.baseUrl + this.getByAdminIDURI,
				this.getBodyTravelsFilter(user_id), environment.api.config).subscribe(
				(data: any) => {
					const toRet = [];
					if (data.data) {
						data.data.forEach((vehicle_server_obj) => {
							const travel_raw = vehicle_server_obj['travel'];
							toRet.push(new Travel(travel_raw));
						});
					}
					resolve(toRet);
				});
			this.busy.setBusy(_http);
		});
	}

	getTravelsCount(user_id: number): Promise<number> {
		if (this.authService.is_admin()) {
			return this.getByAdminIDCount(user_id);
		} else {
			return this.getByUserIDCount(user_id);
		}
	}
	getByAdminIDCount(user_id: number): Promise<number> {
		return new Promise<number>((resolve, reject) => {
			const _http = this.http.post(environment.api.baseUrl + this.getByAdminIDCountURI,
				this.getBodyTravelsFilter(user_id), environment.api.config).subscribe(
				(data: any) => {
					resolve(data.travel);
				});
		});
	}

	getByUserIDCount(user_id: number): Promise<number> {
		return new Promise<number>((resolve, reject) => {
			const _http = this.http.post(environment.api.baseUrl + this.getByUserIDCountURI,
				this.getBodyTravelsFilter(user_id), environment.api.config).subscribe(
				(data: any) => {
					resolve(data.travel);
				});
			this.busy.setBusy(_http);
		});
	}

	approveTravel(travel: Travel, vehicle: Vehicle, automatic: boolean): Promise<Travel> {
		return new Promise<Travel>((resolve, reject) => {
			const _http = this.http.post(environment.api.baseUrl + this.approveURI,
				{
					'travel_id': travel.id.toString(), 'vehicle_id': vehicle.id.toString(), 'automatic': automatic ? '1' : '0',
					'admin_id': this.authService.getAuthenticatedUser().id.toString()
				},
				environment.api.config).subscribe(
				(data: any) => {
					if (data.travel) {
						resolve(new Travel(data.travel));
					} else {
						reject();
					}
				});
			this.busy.setBusy(_http);
		});
	}

	changeVehicleToTravel(travel: Travel, vehicle: Vehicle): Promise<Travel> {
		return new Promise<Travel>( (resolve, reject) => {
			const _http = this.http.post(environment.api.baseUrl + this.changeVehicleToTravelURI,{
					'travel_id': travel.id.toString(),
					'vehicle_id': vehicle.id.toString(),
					'admin_id': this.authService.getAuthenticatedUser().id.toString()
				},
				environment.api.config).subscribe(
			(data: any) => {
				if (data.travel) {
					resolve(new Travel(data.travel));
				} else {
					reject();
				}
			});
			this.busy.setBusy(_http);

			}
		);
	}

	declineTravel(travel: Travel): Promise<Travel> {

		return new Promise<Travel>((resolve, reject) => {
			const _http = this.http.post(environment.api.baseUrl + this.declineURI,
				{
					'travel_id': travel.id.toString(),
					'admin_id': this.authService.getAuthenticatedUser().id.toString()
				},
				environment.api.config).subscribe(
				(data: any) => {
					resolve(new Travel(data.travel));
				});
			this.busy.setBusy(_http);
		});
	}

	restoreTravel(travel: Travel): Promise<Travel> {
		return new Promise<Travel>((resolve, reject) => {
			const _http = this.http.post(environment.api.baseUrl + this.restoreURI,
				{
					'travel_id': travel.id.toString(),
					'admin_id': this.authService.getAuthenticatedUser().id.toString()
				},
				environment.api.config).subscribe(
				(data: any) => {
					resolve(new Travel(data.travel));
				});
			this.busy.setBusy(_http);
		});
	}

	getMaxKm(travel: Travel): Promise<number> {
		return new Promise<number>((resolve, reject) => {
			const _http = this.http.post(environment.api.baseUrl + this.getMaxKmURI,
				{ 'travel_id': travel.id.toString() },
				environment.api.config).subscribe(
				(data: any) => {
					console.log(data);
					resolve(Number(data.travel));
				});
			this.busy.setBusy(_http);
		});
	}


	getMaxKmByVehicleID(vehicle: Vehicle): Promise<number> {
		return new Promise<number>((resolve, reject) => {
			const _http = this.http.post(environment.api.baseUrl + this.getMaxKmByVehicleIDUri,
				{ 'vehicle_id': vehicle.id.toString() },
				environment.api.config).subscribe(
				(data: any) => {
					console.log(data);
					resolve(Number(data.travel));
				});
			this.busy.setBusy(_http);
		});
	}

	getAllTravel(user, count): Promise<Travel[]> {
		return new Promise<Travel[]>((resolve) => {
			const test = this.getBodyTravelsFilter(user.id);
			test.items_per_page = count;
			let url = this.getByUserIDURI;
			if (user.is_admin) {
				url = this.getByAdminIDURI;
			}
			this.http.post(environment.api.baseUrl + url, test, environment.api.config).subscribe(
				(data: any) => {
					const toRet = [];
					if (data.data) {
						data.data.forEach((vehicle_server_obj) => {
							const travel_raw = vehicle_server_obj['travel'];
							toRet.push(new Travel(travel_raw));
						});
					}
					resolve(toRet);
				});
		});
	}

	getImageLogo(path) {
		return this.http.get(path, {
			responseType: 'blob'
		});
	}

	updateTravelKilometers(travel): Promise<Travel> {
		return new Promise<Travel>((resolve, reject) => {
			const url = this.updateKilometers;
			const _http = this.http.post(environment.api.baseUrl + url, travel, environment.api.config).subscribe((data: any) => {
				if (data.travel) {
					const trav = new Travel(data.travel);
					resolve(trav);
				} else {
					reject();
				}
			}, error => {
				console.log(error);
			});
			this.busy.setBusy(_http);
		});
	}

	getTravelForAdminCalendar(park_id: string): Promise<Travel[]> {
		return new Promise<Travel[]>((resolve, reject) => {
			const _http = this.http.post(environment.api.baseUrl + this.getTravelForAdminCalendarURI,
				{ 'park_id': park_id },
				environment.api.config).subscribe(
				(data: any) => {
					resolve(data);
				});
			this.busy.setBusy(_http);
		});
	}

  getTravelsByParkId(park_id: string): Promise<Travel[]> {
    return new Promise<Travel[]>((resolve, reject) => {
      const _http = this.http.post(environment.api.baseUrl + this.getTravelsByParkIdURI,
        {
          'park_id': park_id
        },


        environment.api.config).subscribe(
        (data: any) => {
          resolve(data);
        });
      this.busy.setBusy(_http);
    });
  }

  adminUpdateTravel(travel: any): Promise<Travel> {
    return new Promise<Travel>( (resolve, reject) => {
        const _http = this.http.post(environment.api.baseUrl + this.adminUpdateTravelURI,{
          'travel_id': travel.trv_id.toString(),
          'trv_ended_at': travel.trv_ended_at ? this.dateHandlerService.formatDate(travel.trv_ended_at) : null,
          'trv_start_kilometers': travel.trv_start_kilometers,
          'trv_end_kilometers': travel.trv_end_kilometers,
          'trv_fuel_level': travel.trv_fuel_level
          },
          environment.api.config).subscribe(
          (data: any) => {
            if (data.travel) {
              resolve(new Travel(data.travel));
            } else {
              reject();
            }
          });
        this.busy.setBusy(_http);

      }
    );
  }

  getTravelStatus(travel: any) : string {
    if(travel.trv_handled_at && !travel.trv_started_at && travel.trv_ended_at) {
      return 'annullatoOfficer';
    } else if(travel.trv_handled_at && travel.trv_started_at && travel.trv_ended_at) {
      return 'concluso';
    } else if(travel.trv_handled_at && travel.trv_started_at && !travel.trv_ended_at) {
      return 'inCorso';
    } else if(travel.trv_handled_at && !travel.trv_started_at && !travel.trv_ended_at) {
      return 'approvato';
    } else if(!travel.trv_handled_at && !travel.trv_started_at && !travel.trv_ended_at) {
      return 'richiesto';
    } else if(!travel.trv_handled_at && !travel.trv_started_at && travel.trv_ended_at) {
      return 'annullatoUtente';
    } else {
      return 'errore';
    }
  }

  getTravelStatusDescription(status){
    return this.travels_status_mapping.get(status);
  }

  getTravelMotivations(): Promise<Motivation[]> {
	return new Promise<Motivation[]>((resolve, reject) => {
		const _http = this.http.get(environment.api.baseUrl + this.getTravelMotivationsURI, environment.api.config).subscribe((motivationsData: any) => {
			if (motivationsData.data) {
          		const toRet = [];
		 		 motivationsData.data.forEach(function (motivation_server_obj) {
				  toRet.push(new Motivation(motivation_server_obj["motivation"]));
				});

				toRet.sort((prev: Motivation, next: Motivation) => {
					return new Date(prev.created_at).getTime() - new Date(next.created_at).getTime();
				});

				resolve(toRet);
			  } else {
				reject();
			}
		});
		this.busy.setBusy(_http);
	});
  }

}
